import StyledHeaderMetavalue from '/business/shared/components/widgets/header/__styled__/StyledHeaderApplicationMetavalue';
import type { ReactNode } from 'react';

type HeaderApplicationMetavalueProps = {
  label: ReactNode;
  value: ReactNode;
};

function HeaderApplicationMetavalue({ label, value }: HeaderApplicationMetavalueProps) {
  return (
    <StyledHeaderMetavalue>
      <span>{label}</span>
      <div>{value}</div>
    </StyledHeaderMetavalue>
  );
}

export default HeaderApplicationMetavalue;
